<template>
    <div 
        class="block-play-wheeloffortune"
        :style="`--_items: ${prizes.length}`"
    >
        <div class="block-play-wheeloffortune__inner">
            <div class="block-play-wheeloffortune__stopper">
                <svg 
                class="block-play-wheeloffortune__stoper-icon"
                width="145" height="198" viewBox="0 0 145 198" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <path d="M35.2217 101.217H103.682C105.002 101.217 106.168 102.218 106.833 103.814C107.492 105.397 107.595 107.444 106.858 109.265L72.6279 193.955C71.8813 195.802 70.6139 196.613 69.4521 196.613C68.2903 196.613 67.0221 195.802 66.2754 193.955L32.0449 109.265C31.3088 107.444 31.4108 105.397 32.0703 103.814C32.7356 102.218 33.9017 101.217 35.2217 101.217Z" fill="white" stroke="white"/>
                <g clip-path="url(#clip0_3482_11925)">
                <path d="M160 82.4487C160 123.87 126.421 157.449 85 157.449C43.5786 157.449 10 123.87 10 82.4487C10 41.0274 43.5786 7.44873 85 7.44873C126.421 7.44873 160 41.0274 160 82.4487Z" fill="url(#pattern0_3482_11925)"/>
                <path d="M8.11914 74.0001H132.882V152.196H8.11914V74.0001Z" fill="url(#pattern1_3482_11925)"/>
                <path d="M21.1538 44.0001H58.1538V69.0001H21.1538V44.0001Z" fill="url(#pattern2_3482_11925)"/>
                </g>
                <rect x="5" y="17.2985" width="130.301" height="130.301" rx="65.1503" stroke="white" stroke-width="10"/>
                <rect x="33.2842" y="0.00012207" width="78.4518" height="123.418" fill="url(#pattern3_3482_11925)"/>
                <rect x="101.154" y="21" width="43" height="39" fill="url(#pattern4_3482_11925)"/>
                <defs>
                <pattern id="pattern0_3482_11925" patternContentUnits="objectBoundingBox" width="1" height="1">
                <use xlink:href="#image0_3482_11925" transform="scale(0.00833333)"/>
                </pattern>
                <pattern id="pattern1_3482_11925" patternContentUnits="objectBoundingBox" width="1" height="1">
                <use xlink:href="#image1_3482_11925" transform="scale(0.00704225 0.0112361)"/>
                </pattern>
                <pattern id="pattern2_3482_11925" patternContentUnits="objectBoundingBox" width="1" height="1">
                <use xlink:href="#image2_3482_11925" transform="scale(0.027027 0.04)"/>
                </pattern>
                <pattern id="pattern3_3482_11925" patternContentUnits="objectBoundingBox" width="1" height="1">
                <use xlink:href="#image3_3482_11925" transform="scale(0.0121951 0.00775194)"/>
                </pattern>
                <pattern id="pattern4_3482_11925" patternContentUnits="objectBoundingBox" width="1" height="1">
                <use xlink:href="#image4_3482_11925" transform="scale(0.0232558 0.025641)"/>
                </pattern>
                <clipPath id="clip0_3482_11925">
                <rect x="10" y="22.2985" width="120.301" height="120.301" rx="60.1503" fill="white"/>
                </clipPath>
                <image id="image0_3482_11925" width="120" height="120" preserveAspectRatio="none" xlink:href="data:image/jpeg;base64,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"/>
                <image id="image1_3482_11925" width="142" height="89" preserveAspectRatio="none" xlink:href="data:image/png;base64,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"/>
                <image id="image2_3482_11925" width="37" height="25" preserveAspectRatio="none" xlink:href="data:image/png;base64,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"/>
                <image id="image3_3482_11925" width="82" height="129" preserveAspectRatio="none" xlink:href="data:image/png;base64,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"/>
                <image id="image4_3482_11925" width="43" height="39" preserveAspectRatio="none" xlink:href="data:image/png;base64,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"/>
                </defs>
                </svg>
            </div>

            <div class="block-play-wheeloffortune__border-outer">
                <div class="block-play-wheeloffortune__center-dot"></div>

                <div class="block-play-wheeloffortune__border-inner">
                    <div
                        ref="wheelElementRef"
                        class="block-play-wheeloffortune__wheel"
                        :style="wheelStyle"
                    >
                        <div 
                            v-for="(prize, index) of prizes"
                            :key="prize._key"
                            :style="`--_idx: ${index + 1}`"
                            class="block-play-wheeloffortune__wheel-item"
                        >
                            <div 
                                v-if="prize.isVoucher"
                                class="block-play-wheeloffortune__voucher"
                            >
                                <span class="block-play-wheeloffortune__voucher-currency">CHF</span>
                                <span class="block-play-wheeloffortune__voucher-amount">{{ prize.worth }}</span>
                            </div>

                            <div 
                                v-else
                                class="block-play-wheeloffortune__physical-prize"
                            >
                                <AtomImage
                                    v-if="prize.image?.src"
                                    :image="prize.image"
                                    behaviour="cover"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="block-play-wheeloffortune__buttons">
                <AtomButton
                    v-if="!spinFinished && !isSpinLocked"
                    :text="spinButtonText"
                    :callback="spin"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    spinButtonText: {
        type: String,
        default: 'Glücksrad drehen',
    },

    prizes: {
        type: Array,
        default: () => [
            {
                worth: 200,
                isVoucher: true,
            },
            
            {
                // Hofladen
                image: {
                    src: '/images/prizes/milchbuur.jpg',
                    alt: 'Hofladen',
                },
                isVoucher: false,
                id: 3,
            },
            
            {
                worth: 100,
                isVoucher: true,
            },

            {
                // Raclette Pfännli
                image: {
                    src: '/images/prizes/raclettepfaennli.jpg',
                    alt: 'Raclette Pfännli',
                },
                isVoucher: false,
                id: 4,
            },

            {
                worth: 50,
                isVoucher: true,
            },

            {
                // Hofladen
                image: {
                    src: '/images/prizes/milchbuur.jpg',
                    alt: 'Hofladen',
                },
                isVoucher: false,
                id: 3,
            },
            
            {
                worth: 25,
                isVoucher: true,
            },

            {
                // Überraschungspäckli
                image: {
                    src: '/images/prizes/ueberraschungspaeckli.jpg',
                    alt: 'Überraschungspäckli',
                },
                isVoucher: false,
                id: 5,
            },

            {
                worth: 50,
                isVoucher: true,
            },

            {
                // Raclette Pfännli
                image: {
                    src: '/images/prizes/raclettepfaennli.jpg',
                    alt: 'Raclette Pfännli',
                },
                isVoucher: false,
                id: 4,
            },
            
            {
                worth: 25,
                isVoucher: true,
            },
            
            {
                // Überraschungspäckli
                image: {
                    src: '/images/prizes/ueberraschungspaeckli.jpg',
                    alt: 'Überraschungspäckli',
                },
                isVoucher: false,
                id: 5,
            },
        ],
    }
});


const wheelElementRef = ref(null);
const currentRotationDeg = ref(0);
const isSpinning = ref(false);
const isSpinLocked = ref(false);
const idleRotationSpeedDegPerSecond = 8;
const idleAnimationFrameId = ref(null);
const idleLastTimestampMs = ref(0);
const spinDurationMs = 6200;
const fullSpins = 6;


const wheelStyle = computed(() => ({
    transform: `rotate(${currentRotationDeg.value}deg)`,
    transition: isSpinning.value
        ? `transform ${spinDurationMs}ms cubic-bezier(0.12, 0.8, 0.18, 1)`
        : 'none',
}));

const normalizeAngle = (angle) => ((angle % 360) + 360) % 360;
const toFiniteNumber = (value) => {
    const parsedNumber = Number(value);
    return Number.isFinite(parsedNumber) ? parsedNumber : null;
};
const getFirstFiniteNumber = (...values) => {
    for(const value of values) {
        const parsedNumber = toFiniteNumber(value);

        if(parsedNumber !== null) {
            return parsedNumber;
        }
    }

    return null;
};

function stopIdleRotation() {
    if(idleAnimationFrameId.value !== null) {
        cancelAnimationFrame(idleAnimationFrameId.value);
        idleAnimationFrameId.value = null;
    }

    idleLastTimestampMs.value = 0;
}

function startIdleRotation() {
    if(idleAnimationFrameId.value !== null) {
        return;
    }

    const tick = (timestampMs) => {
        if(isSpinning.value) {
            stopIdleRotation();
            return;
        }

        if(!idleLastTimestampMs.value) {
            idleLastTimestampMs.value = timestampMs;
        }

        const deltaSeconds = (timestampMs - idleLastTimestampMs.value) / 1000;
        idleLastTimestampMs.value = timestampMs;

        currentRotationDeg.value = normalizeAngle(
            currentRotationDeg.value + (deltaSeconds * idleRotationSpeedDegPerSecond),
        );

        idleAnimationFrameId.value = requestAnimationFrame(tick);
    };

    idleAnimationFrameId.value = requestAnimationFrame(tick);
}

function getPrizeExpectation(prizeCharacteristics) {
    const responseKey = String(prizeCharacteristics?.key ?? '').toLowerCase();
    const responseWorth = getFirstFiniteNumber(
        prizeCharacteristics?.worth_in_chf,
    );
    const responseId = prizeCharacteristics?.id != null ? String(prizeCharacteristics.id) : null;
    const isVoucherResponse = responseKey === 'voucher';

    return {
        responseKey,
        responseWorth,
        responseId,
        isVoucherResponse,
    };
}

function getTargetRotationDeg(prizeIndex) {
    if(prizeIndex < 0 || !props.prizes.length) {
        return null;
    }

    const segmentAngle = 360 / props.prizes.length;
    const firstSegmentCenterDeg = 180;
    const segmentCenterDeg = normalizeAngle(firstSegmentCenterDeg + (prizeIndex * segmentAngle));
    const topCenterDeg = 270;
    const targetAngleInCircle = normalizeAngle(topCenterDeg - segmentCenterDeg);
    const currentAngleInCircle = normalizeAngle(currentRotationDeg.value);
    const deltaToTarget = normalizeAngle(targetAngleInCircle - currentAngleInCircle);

    return currentRotationDeg.value + (fullSpins * 360) + deltaToTarget;
}

function getWheelPrizeIndex(prizeCharacteristics) {
    const {
        responseWorth,
        responseId,
        isVoucherResponse,
    } = getPrizeExpectation(prizeCharacteristics);

    if(isVoucherResponse) {
        if(responseWorth === null) {
            return -1;
        }

        const voucherPrizeIndex = props.prizes.findIndex((prize) => (
            prize.isVoucher
            && toFiniteNumber(prize.worth) === responseWorth
        ));

        if(voucherPrizeIndex !== -1) {
            return voucherPrizeIndex;
        }

        // If the API sent a voucher worth but we cannot map it, abort instead of
        // incorrectly falling back to a physical-prize id.
        return -1;
    }

    if(responseId !== null) {
        const physicalPrizeIndex = props.prizes.findIndex((prize) => (
            !prize.isVoucher
            && prize.id != null
            && String(prize.id) === responseId
        ));

        if(physicalPrizeIndex !== -1) {
            return physicalPrizeIndex;
        }
    }

    return -1;
}

function validateWheelPrizeSelection(prizeCharacteristics, prizeIndex) {
    if(prizeIndex < 0 || !props.prizes[prizeIndex]) {
        return {
            isValid: false,
            reason: 'invalid-prize-index',
        };
    }

    const selectedPrize = props.prizes[prizeIndex];
    const {
        responseWorth,
        responseId,
        isVoucherResponse,
    } = getPrizeExpectation(prizeCharacteristics);

    if(isVoucherResponse) {
        if(responseWorth === null) {
            return {
                isValid: false,
                reason: 'voucher-response-missing-worth',
            };
        }

        if(!selectedPrize.isVoucher) {
            return {
                isValid: false,
                reason: 'voucher-response-selected-physical-prize',
            };
        }

        if(toFiniteNumber(selectedPrize.worth) !== responseWorth) {
            return {
                isValid: false,
                reason: 'voucher-worth-mismatch',
            };
        }

        return { isValid: true };
    }

    if(responseId !== null) {
        if(selectedPrize.isVoucher) {
            return {
                isValid: false,
                reason: 'physical-response-selected-voucher-prize',
            };
        }

        if(String(selectedPrize.id) !== responseId) {
            return {
                isValid: false,
                reason: 'physical-id-mismatch',
            };
        }

        return { isValid: true };
    }

    return {
        isValid: false,
        reason: 'response-could-not-be-classified',
    };
}

function waitForWheelAnimationEnd() {
    const wheelElement = wheelElementRef.value;

    if(!wheelElement) {
        return new Promise((resolve) => {
            setTimeout(resolve, spinDurationMs + 150);
        });
    }

    return new Promise((resolve) => {
        let hasResolved = false;
        let fallbackTimeoutId = null;

        const finish = () => {
            if(hasResolved) {
                return;
            }

            hasResolved = true;
            wheelElement.removeEventListener('transitionend', onTransitionEnd);

            if(fallbackTimeoutId) {
                clearTimeout(fallbackTimeoutId);
            }

            resolve();
        };

        const onTransitionEnd = (event) => {
            if(event.target !== wheelElement || event.propertyName !== 'transform') {
                return;
            }

            finish();
        };

        wheelElement.addEventListener('transitionend', onTransitionEnd);
        fallbackTimeoutId = setTimeout(finish, spinDurationMs + 300);
    });
}

onMounted(() => {
    startIdleRotation();
});

onBeforeUnmount(() => {
    stopIdleRotation();
});

watch(isSpinning, (spinning) => {
    if(!spinning) {
        startIdleRotation();
    }
});

/* 
    Get the price data
*/
const receiptDocumentIdCookie = useCookie('receiptDocumentId');
const localePath = useLocalePath();


const { triggerConfetti } = useConfetti();

/* 
    Spin
*/
const spinFinished = ref(false);
const spin = async () => {
    if(isSpinLocked.value) {
        return;
    }

    isSpinLocked.value = true;

    try {
        let priceData = null;
        try {
            const response = await useDirectApiFetch('/api/receipts/result', {
                method: 'POST',
                body: {
                    receipt_document_id: receiptDocumentIdCookie.value,
                },
            });
            priceData = response?.prize_characteristics ?? null;
        } catch (error) {
            useSentryError(error, {
                useThrow: false,
                response: error?.data ?? null,
            });
            return;
        }
        if(!priceData) {
            return navigateTo(localePath('/'));
        }

        const wheelPrize = getWheelPrizeIndex(priceData);
        const selectionValidation = validateWheelPrizeSelection(priceData, wheelPrize);

        if(!selectionValidation.isValid) {
            useSentryError(new Error(`Wheel self-check failed: ${selectionValidation.reason}`), {
                useThrow: false,
                response: {
                    prizeCharacteristics: priceData,
                    selectedPrizeIndex: wheelPrize,
                    selectedPrize: props.prizes[wheelPrize] ?? null,
                    availablePrizes: props.prizes.map((prize) => ({
                        isVoucher: prize.isVoucher,
                        worth: prize.worth,
                        id: prize.id,
                    })),
                },
            });
            return;
        }

        const targetRotationDeg = getTargetRotationDeg(wheelPrize);

        if(targetRotationDeg === null) {
            useSentryError(new Error('Wheel target rotation could not be computed'), {
                useThrow: false,
                response: {
                    prizeCharacteristics: priceData,
                    selectedPrizeIndex: wheelPrize,
                    selectedPrize: props.prizes[wheelPrize] ?? null,
                },
            });
            return;
        }

        stopIdleRotation();
        isSpinning.value = true;
        const spinFinishedPromise = waitForWheelAnimationEnd();
        currentRotationDeg.value = targetRotationDeg;
        await spinFinishedPromise;
        spinFinished.value = true;
        triggerConfetti();
        await sleep(3000);
        await navigateTo(localePath(`/win`));
    } finally {
        isSpinning.value = false;
        isSpinLocked.value = false;
    }
};
</script>

<style lang="scss" scoped>
.block-play-wheeloffortune {
    @include wrapper-layout;
    @include fluid-simple('--box-shadow-size', 5px, 15px);
    @include fluid-simple('padding-top', 40px, 76px);

    display: flex;
    justify-content: center;
    margin-bottom: var(--m-bottom--big);

}

.block-play-wheeloffortune__inner {
    @include fluid-simple('max-width', 500px, 700px);
    position: relative;
    width: 100%;
}

.block-play-wheeloffortune__border-outer {
    @include fluid-simple('--border-width', 7px, 15px);
    
    position: relative;
    border: var(--border-width) solid var(--c-primary-500);
    border-radius: var(--b-radius--full);
    filter: drop-shadow(0 0 var(--box-shadow-size) rgba(0, 0, 0, 0.25));
}

.block-play-wheeloffortune__center-dot {
    @include fluid-simple('width', 35px, 75px);
    @include fluid-simple('height', 35px, 75px);

    position: absolute;
    z-index: 10;
    top: 50%;
    left: 50%;
    border-radius: var(--b-radius--full);
    background-color: var(--c-primary-500);
    filter: drop-shadow(0 0 15px rgba(0, 0, 0, 0.25));
    transform: translate(-50%, -50%);
}

.block-play-wheeloffortune__border-inner {
    @include fluid-simple('--border-width', 3px, 10px);
    
    border: var(--border-width) solid var(--c-white);
    border-radius: var(--b-radius--full);
    filter: drop-shadow(0 0 var(--box-shadow-size) rgba(0, 0, 0, 0.25));
}

.block-play-wheeloffortune__stopper {
    position: absolute;
    z-index: 10;
    top: 0;
    left: 50%;
    transform: translateX(-48%) translateY(-52%);
}


.block-play-wheeloffortune__stoper-icon {
    @include fluid-simple('width', 55px, 105px);
}

:where(.block-play-wheeloffortune__wheel) {
    all: unset;
    position: relative;
    display: grid;
    overflow: hidden;
    border-radius: var(--b-radius--full);
    aspect-ratio: 1 / 1;
    background: Canvas;
    container-type: inline-size;
    direction: ltr;
    place-content: center start;
    will-change: transform;

    &::after {
        position: absolute;
        z-index: 2;
        border-radius: inherit;
        box-shadow: inset 0 0 28px rgba(0, 0, 0, 0.28);
        content: '';
        inset: 0;
        pointer-events: none;
    }

    .block-play-wheeloffortune__wheel-item {
        @include fluid-simple('padding-right', 35px, 95px);
        
        position: relative;
        z-index: 1;
        display: flex;
        width: 50cqi;
        align-content: center;
        align-items: center;
        justify-content: center;
        aspect-ratio: 1 / calc( 2 * tan(180deg / var(--_items)));
        clip-path: polygon(0% 0, 100% 50%, 0% 100%);
        grid-area: 1 / -1;
        list-style: none;
        rotate: calc(360deg / var(--_items) * calc(var(--_idx) - 1));
        transform-origin: center right;

        &:nth-child(odd) {
            background-color: #CCDCF2;
        }

        &:nth-child(even) {
            background-color: #F2F6FC;
        }

        &::after {
            @include fluid-simple('left', 10px, 20px);
            @include fluid-simple('width', 5px, 10px);
            @include fluid-simple('height', 5px, 10px);

            position: absolute;
            z-index: 20;
            top: 0;
            bottom: 0;
            border-radius: var(--b-radius--full);
            margin: auto;
            background-color: var(--c-primary-500);
            content: '';
            filter: drop-shadow(0 0 15px rgba(0, 0, 0, 0.25));
        }
    }
}

.block-play-wheeloffortune__buttons {
    display: flex;
    justify-content: center;
    margin-top: 40px;
}

.block-play-wheeloffortune__physical-prize {
    @include fluid-simple('width', 35px, 70px);
    @include fluid-simple('height', 35px, 70px);
    @include fluid-simple('--border-width', 2px, 3px);
    
    overflow: hidden;
    border: var(--border-width) solid var(--c-primary-500);
    border-radius: var(--b-radius--full);
    background-color: var(--c-white);
    transform: rotate(-90deg);
}

.block-play-wheeloffortune__voucher {
    @include fluid-simple('column-gap', 2px, 10px);

    display: flex;
    flex-direction: row;
    align-items: center;
    color: var(--c-primary-500);
    font-family: var(--f-family--secondary);
    font-weight: var(--f-weight--700);
}

.block-play-wheeloffortune__voucher-currency,
.block-play-wheeloffortune__voucher-amount {
    text-shadow: 0 1px 0 rgba(255,255,255,.35), 0 -1px 2px rgba(0,0,0,.25);
}

.block-play-wheeloffortune__voucher-currency {
    @include fluid-simple('font-size', 8px, 16px);
}

.block-play-wheeloffortune__voucher-amount {
    @include fluid-simple('font-size', 23px, 50px);
}
</style>

